import React from 'react';
// Constants
import { CompanyName, MainTitle } from '../../utils/Constants';

function BannerImage() {
  return (
    <section
      className='grid relative w-full border-b-2 border-solid border-colour7 bg-center lg:bg-cover h-[300px] bg-no-repeat bg-eyes bg-fixed'
      aria-labelledby='big-image-heading'
    >
      <div className='absolute grid items-center left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full text-center'>
        <div className='grid h-fit gap-12'>
          <h4 className='text-5xl md:text-5xl lg:text-7xl font-bold text-colour7 font-titleFont text_shadow_strong'>
            {CompanyName}
          </h4>
          <h5 className='text-3xl md:text-5xl lg:text-4xl font-kugile font-bold text-colour1 text_shadow_strong'>
            {MainTitle}
          </h5>
        </div>
      </div>
    </section>
  );
}

export default BannerImage;
